import script from "./customerCouponList.vue?vue&type=script&setup=true&lang=js"
export * from "./customerCouponList.vue?vue&type=script&setup=true&lang=js"

import "./customerCouponList.vue?vue&type=style&index=0&id=347b27c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-347b27c6"]])

export default __exports__